import { user1 } from 'app/mockdata/user';

export const auth = {
  community: 'testCommunity',
  user: user1,
  isAuthenticated: true,
};
